import Navbar from '../home/components/Navbar';
import About from '../home/components/About';
import Footer from '../home/components/Footer';
import SEOHead from '../../components/base/SEOHead';

export default function AboutPage() {
  const siteUrl = import.meta.env.VITE_SITE_URL;

  const jsonLd = {
    "@context": "https://schema.org",
    "@graph": [
      {
        "@type": "BreadcrumbList",
        "itemListElement": [
          {
            "@type": "ListItem",
            "position": 1,
            "name": "Home",
            "item": siteUrl
          },
          {
            "@type": "ListItem",
            "position": 2,
            "name": "About",
            "item": `${siteUrl}/about`
          }
        ]
      },
      {
        "@type": "AboutPage",
        "name": "About King Square Club",
        "description": "Discover King Square Club, Benin City's premier luxury nightclub. Learn about our exclusive VIP experiences, world-class entertainment, and commitment to unforgettable nightlife.",
        "url": `${siteUrl}/about`,
        "breadcrumb": {
          "@type": "BreadcrumbList",
          "itemListElement": [
            { "@type": "ListItem", "position": 1, "name": "Home", "item": siteUrl },
            { "@type": "ListItem", "position": 2, "name": "About", "item": `${siteUrl}/about` }
          ]
        },
        "mainEntity": {
          "@type": "NightClub",
          "name": "King Square Club",
          "description": "Benin City's premier luxury nightclub offering exclusive VIP experiences, world-class entertainment, and unforgettable nights since our establishment.",
          "address": {
            "@type": "PostalAddress",
            "streetAddress": "148 Airport Rd",
            "addressLocality": "Benin City",
            "postalCode": "300102",
            "addressRegion": "Edo",
            "addressCountry": "NG"
          },
          "telephone": "+2348039496446",
          "priceRange": "₦₦₦",
          "openingHoursSpecification": [
            {
              "@type": "OpeningHoursSpecification",
              "dayOfWeek": ["Friday", "Saturday", "Sunday"],
              "opens": "23:00",
              "closes": "05:00"
            }
          ]
        }
      }
    ]
  };

  return (
    <div className="min-h-screen bg-black">
      <SEOHead
        title="About Us - King Square Club | Premier Luxury Nightclub in Benin City"
        description="Discover King Square Club, Benin City's premier luxury nightclub. Learn about our exclusive VIP experiences, world-class entertainment, and commitment to unforgettable nightlife."
        keywords="about King Square Club, luxury nightclub Benin City, premium entertainment Edo, VIP nightlife Nigeria, exclusive club Benin"
        canonical={`${siteUrl}/about`}
        ogTitle="About King Square Club"
        ogDescription="Benin City's premier luxury nightclub offering exclusive VIP experiences and world-class entertainment."
        ogImage="https://public.readdy.ai/ai/img_res/6d5a54e7eba0ddfbaec069a0745bba74.jpg"
        ogType="website"
        jsonLd={jsonLd}
      />
      <Navbar />
      <div className="pt-24">
        <About />
      </div>
      <Footer />
    </div>
  );
}
